module.exports = __webpack_public_path__ + "img/bg-login-participant.a7ad846c.jpg";